import React, { Component } from 'react';
import './GroupCompanyRegisterDashboard.css';
import { Breadcrumb, Select, Button, message, Input, Divider } from 'antd';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import GroupCompanyRegisterGrid from './GroupCompanyRegisterGrid';
import GroupCompanyRegisterDetailDialog from './GroupCompanyRegisterDetailDialog';
import AddOrEditGroupCompanyRegisterModalDialog from './AddOrEditGroupCompanyRegisterModalDialog';
import DelGroupCompanyRegisterModalDialog from './DelGroupCompanyRegisterModalDialog';
import OperationRecordDialog from '../../../common/operationRcd/components/OperationRecordDialog';

const INFORMATION_OPTIONS = [
    'ALL',
    'BusinessAddress',
    'CompanyDocs',
    'EntityName_Other',
    'EntityName_Eng',
    'GIIN',
    'IncorpNo',
    'IncorpPlace',
    'LegalStructure',
    'LEI',
    'License',
    'Others',
    'RegisteredAddress',
    'Regulator',
    'Seal',
    'Tax ID No',
    'Website',
];

class GroupCompanyRegisterDashboard extends Component {
    componentDidMount() {
        this.props.queryGroupCompanyRegister();
    }

    componentDidUpdate() {
        const {
            queryGroupCompanyRegisterStatus,
            queryGroupCompanyRegisterResp,
        } = this.props;
        if (queryGroupCompanyRegisterStatus === ACTION_STATUS.SUCCESS) {
            this.props.initQueryGroupCompanyRegisterActionStatus();
        }
        if (queryGroupCompanyRegisterStatus === ACTION_STATUS.ERROR) {
            let err = 'Query Group Company Register failed';
            if (!!queryGroupCompanyRegisterResp && !!queryGroupCompanyRegisterResp.respMessage) {
                err = queryGroupCompanyRegisterResp.respMessage;
            }
            message.error(err);
            this.props.initQueryGroupCompanyRegisterActionStatus();
        }
    }

    refreshBtnOnClicked = () => {
        this.props.queryGroupCompanyRegister();
    }

    addOrEditGroupCompanyRegisterBtnOnClicked = mode => {
        if (mode === 'ADD') {
            this.props.openAddOrEditGroupCompanyRegisterModal(mode, null);
            return;
        }
        const { selectedGroupCompanyRegisterArray } = this.props;
        if (!selectedGroupCompanyRegisterArray || selectedGroupCompanyRegisterArray.length !== 1) {
            message.warn('Please select one and only one Group Company Register');
            return;
        }
        this.props.openAddOrEditGroupCompanyRegisterModal(mode, selectedGroupCompanyRegisterArray[0]);
    }

    delGroupCompanyRegisterBtnOnClicked = () => {
        const { selectedGroupCompanyRegisterArray } = this.props;
        if (!selectedGroupCompanyRegisterArray || selectedGroupCompanyRegisterArray.length !== 1) {
            message.warn('Please select one and only one Group Company Register');
            return;
        }
        this.props.openDelGroupCompanyRegisterModal(selectedGroupCompanyRegisterArray[0]);
    }

    opRcdCustomColumns = ['operator', 'operateTime', 'dataId', 'operateType', 'comments', 'before', 'after'];

    operationRecordBtnOnClicked = () => {
        const { selectedGroupCompanyRegisterArray } = this.props;
        const queryFields = { module: 'GroupCompanyRegister' };
        if (selectedGroupCompanyRegisterArray && selectedGroupCompanyRegisterArray.length > 0) {
            queryFields.dataId = selectedGroupCompanyRegisterArray.map(item => item.id).join(',');
        }
        this.props.doOperationRecordAction({
            action: 'OPEN_AND_QUERY',
            queryFields,
            customColumns: this.opRcdCustomColumns,
        });
    };

    render() {
        const {
            queryFields,
            queryGroupCompanyRegisterStatus,
        } = this.props;

        const refreshBtnIsLoading = queryGroupCompanyRegisterStatus === ACTION_STATUS.LOGINING;

        return (
            <div className='GroupCompanyRegisterWrapper'>
                <div className='breadcrumbWrapper'>
                    <Breadcrumb>
                        <Breadcrumb.Item>Pinpoint Group</Breadcrumb.Item>
                        <Breadcrumb.Item>Group Company Register</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className='OperationBar'>
                    <Input
                        size='small'
                        style={{ width: 160, marginLeft: 10 }}
                        placeholder='Company Code'
                        value={queryFields.companyCode}
                        onChange={e => this.props.groupCompanyRegisterQueryChangeInput({ name: 'companyCode', value: e.target.value })}
                    />
                    <Select
                        size='small'
                        style={{ width: 180, marginLeft: 10 }}
                        placeholder='Information'
                        value={queryFields.information}
                        allowClear
                        onChange={value => this.props.groupCompanyRegisterQueryChangeInput({ name: 'information', value: value || 'ALL' })}
                    >
                        {INFORMATION_OPTIONS.map(item => (
                            <Select.Option key={item} value={item}>
                                {item}
                            </Select.Option>
                        ))}
                    </Select>
                    <Select
                        size='small'
                        style={{ width: 120, marginLeft: 10 }}
                        value={queryFields.currentStatus}
                        onChange={value => this.props.groupCompanyRegisterQueryChangeInput({ name: 'currentStatus', value })}
                    >
                        <Select.Option key='Current'>Current</Select.Option>
                        <Select.Option key='All'>All</Select.Option>
                    </Select>

                    <Button
                        onClick={this.refreshBtnOnClicked}
                        loading={refreshBtnIsLoading}
                        size='small'
                        style={{ marginLeft: 10 }}
                        type='primary'
                        icon='search'
                    />

                    <Divider type='vertical' />

                    <Button
                        onClick={() => this.addOrEditGroupCompanyRegisterBtnOnClicked('ADD')}
                        size='small'
                        className='positive-button'>
                        Add
                    </Button>
                    <Button
                        onClick={() => this.addOrEditGroupCompanyRegisterBtnOnClicked('EDIT')}
                        size='small'
                        style={{ marginLeft: 10 }}
                        type='primary'>
                        Edit
                    </Button>
                    <Button
                        onClick={() => this.addOrEditGroupCompanyRegisterBtnOnClicked('COPY')}
                        size='small'
                        style={{ marginLeft: 10 }}
                        type='primary'>
                        Copy
                    </Button>
                    <Button
                        onClick={this.delGroupCompanyRegisterBtnOnClicked}
                        size='small'
                        style={{ marginLeft: 10 }}
                        className='negative-button'>
                        Del
                    </Button>

                    <Divider type='vertical' />

                    <Button
                        onClick={this.operationRecordBtnOnClicked}
                        size='small'
                        type='primary'>
                        Operation Record
                    </Button>
                </div>

                <div className='GroupCompanyRegisterGrid'><GroupCompanyRegisterGrid {...this.props} /></div>
                <GroupCompanyRegisterDetailDialog {...this.props} />
                <AddOrEditGroupCompanyRegisterModalDialog {...this.props} />
                <DelGroupCompanyRegisterModalDialog {...this.props} />
                <OperationRecordDialog {...this.props} />
            </div>
        );
    }
}

export default GroupCompanyRegisterDashboard;
